// Regular expressions for detecting contact information
const EMAIL_REGEX = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/g;
const PHONE_REGEX = /(?:\+?1[-.]?)?\(?([0-9]{3})\)?[-.]?([0-9]{3})[-.]?([0-9]{4})/g;
const URL_REGEX = /(https?:\/\/[^\s]+)/g;
const SOCIAL_MEDIA_REGEX = /(?:^|\s)[@#]([a-zA-Z0-9_]+)/g;

export const sanitizeMessage = (text: string): { isValid: boolean; sanitizedText: string } => {
  // Check for email addresses
  if (EMAIL_REGEX.test(text)) {
    return {
      isValid: false,
      sanitizedText: text.replace(EMAIL_REGEX, '[email removed]')
    };
  }

  // Check for phone numbers
  if (PHONE_REGEX.test(text)) {
    return {
      isValid: false,
      sanitizedText: text.replace(PHONE_REGEX, '[phone number removed]')
    };
  }

  // Check for URLs
  if (URL_REGEX.test(text)) {
    return {
      isValid: false,
      sanitizedText: text.replace(URL_REGEX, '[link removed]')
    };
  }

  // Check for social media handles
  if (SOCIAL_MEDIA_REGEX.test(text)) {
    return {
      isValid: false,
      sanitizedText: text.replace(SOCIAL_MEDIA_REGEX, '[social media handle removed]')
    };
  }

  // Check for common contact phrases
  const contactPhrases = [
    'whatsapp',
    'telegram',
    'facebook',
    'instagram',
    'snapchat',
    'discord',
    'skype',
    'wechat',
    'line',
    'viber',
    'signal',
    'call me',
    'text me',
    'dm me',
    'message me',
    'contact me',
    'reach me'
  ];

  const lowerText = text.toLowerCase();
  for (const phrase of contactPhrases) {
    if (lowerText.includes(phrase)) {
      return {
        isValid: false,
        sanitizedText: text.replace(new RegExp(phrase, 'gi'), '[contact method removed]')
      };
    }
  }

  return {
    isValid: true,
    sanitizedText: text
  };
};

export const sanitizeDescription = (text: string): string => {
  let sanitized = text;

  // Remove email addresses
  sanitized = sanitized.replace(EMAIL_REGEX, '[email removed]');

  // Remove phone numbers
  sanitized = sanitized.replace(PHONE_REGEX, '[phone number removed]');

  // Remove URLs
  sanitized = sanitized.replace(URL_REGEX, '[link removed]');

  // Remove social media handles
  sanitized = sanitized.replace(SOCIAL_MEDIA_REGEX, '[social media handle removed]');

  // Remove common contact phrases
  const contactPhrases = [
    'whatsapp',
    'telegram',
    'facebook',
    'instagram',
    'snapchat',
    'discord',
    'skype',
    'wechat',
    'line',
    'viber',
    'signal',
    'call me',
    'text me',
    'dm me',
    'message me',
    'contact me',
    'reach me'
  ];

  for (const phrase of contactPhrases) {
    sanitized = sanitized.replace(new RegExp(phrase, 'gi'), '[contact method removed]');
  }

  return sanitized;
};